import { isNullish } from "./type-util";

/**
 * Resolves an object property from a string representing the path in dot notation.
 */
export function deepAccess(source, path, defaultValue) {
  let parts = Array.isArray(path) ? path.slice() : String(path).split(".");
  let prop = parts.shift();
  let result = source;
  if (isNullish(result)) {
    return defaultValue;
  }
  while (prop) {
    if (isNullish(result[prop])) {
      return defaultValue;
    } else {
      result = result[prop];
    }
    prop = parts.shift();
  }
  return result;
}

/**
 * Creates a shallow copy of an object including the given keys.
 */
export function pick(obj, keys) {
  const result = {};
  keys.forEach(key => {
    if (key in obj) {
      // @ts-ignore
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Creates a shallow copy of an object excluding the given properties.
 */
export function omit(obj, keys) {
  const result = Object.assign({}, obj);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    delete result[key];
  }
  return result;
}